module.exports = __webpack_public_path__ + "static/media/auchan4.13e48b07.jpg";